---
title: 🎉 Newbie Field Day & Hams at the Park 📡
date: 2025-05-17
endDate: 2025-05-17
location: 5168 Robinson Park Rd, Moscow, ID 83843
coordinates: 46.756408, -116.908153
description: Join us for “Hams at the Park” and our Newbie Field Day course—learn radio basics, proper on-air etiquette, programming, phonetics, and more, plus on-site testing! 🚀
published: true
---

# 📻 Hams at the Park & Newbie Field Day 🎓

*Come spend the afternoon with the Do Something Amateur Radio Club! 🌲*

---

## 📡 Hams at the Park

- **🕛 Time:** 12:00 PM – 5:00 PM PST  
- **📍 Location:** [5168 Robinson Park Rd, Moscow, ID 83843](https://maps.app.goo.gl/WRXSWaVjQQcCwcFG7)  
- **🔍 What to Expect:**  
  - 🎙️ Drop-in demonstrations of HF, VHF, and UHF operating  
  - 📻 Talk-in on **146.820 MHz** (– Offset, 127.3 Hz PL)  
  - 📡 Club station **K7DSA** on-air for live contacts  
  - 📝 On-site license testing opportunity (pre-registration required)  
    - [Register Here](https://ham.study/sessions/681ac3aa296cf32e6d6db658/1)  
    - [Study Here](https://ham.study)  

---

## 🏫 Newbie Field Day Course

- **🕒 Time:** 3:00 PM – 5:00 PM PST  
- **🛠️ Course Format:** 5–6 hands-on stations  
- **📋 Class Content:**  
  1. **🔧 Radio Programming 101** – Learn to load frequencies and settings  
  2. **🎙️ On-Air Etiquette & Phonetics** – Proper procedures, phonetic alphabets, and practice calls  
  3. **📶 VHF/UHF Simplex & Repeaters** – Making local contacts and repeater etiquette  
  4. **🎚️ Mic & Audio Setup** – Setting mic gain, noise reduction, and clear audio  

- **👥 Who Should Attend:**  
  - 🆕 New licensees (Technician & above)  
  - 🤔 Anyone curious about ham radio operations  
  - 💪 Those wanting to build confidence  
  - 📡 Those who want to learn the basics of ham radio  

---

<div class="mb-8">
  <iframe
    title="Map of Robinson Park - Newbie Field Day & Hams at the Park location"
    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2733.443665128423!2d-116.90822274192033!3d46.75615070842193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDbCsDQ1JzIzLjEiTiAxMTbCsDU0JzI5LjQiVw!5e0!3m2!1sen!2sus!4v1746738682398!5m2!1sen!2sus"
    width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
    referrerpolicy="no-referrer-when-downgrade">
  </iframe>
</div>

---

## 🧰 What to Bring

- 📻 Your handheld or mobile radio (if you have one)  
- 📝 Notebook & pen  
- 💧 Bottle of water and snacks  
- 🧥 Warm layers (spring in North Idaho can be cool)  

---

## 🎁 What Will Be Provided

- 📟 Practice radios  
- 🏗️ Various antennas  
- 🔌 Programming cables  

---

## 🔗 Resources & Links

- [📖 Phonetic Alphabet Cheat Sheet](https://en.wikipedia.org/wiki/NATO_phonetic_alphabet)  
- [📝 License Testing Info](https://ham.study/sessions/681ac3aa296cf32e6d6db658/1)  
- [🎯 Ham Study](https://ham.study)  

---

## 📬 RSVP & Contact

To help us plan for test sessions and course materials, please **RSVP** by emailing [contact@dsarc.us](/contact) or join our Discord at  
› <https://discord.gg/432vsVAuwZ>  

Questions? Reach out to **Austin (KF7SIW)** on-air or via email. ✉️  
